import { useEffect } from "react";
import SEO from "./SEO";

const Terms = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
      <div className="max-w-5xl mx-auto px-4 py-12 text-gray-800 leading-relaxed shadow-2xl m-10">
        <SEO
  title="Terms and Conditions | Pufframa – Nicotine Product Website Usage Policy"
  description="Review the full terms and conditions for using Pufframa.com. Learn about copyright, user conduct, liabilities, third-party links, and legal jurisdiction."
  url="https://pufframa.com/terms-and-conditions"
  keywords="terms and conditions, pufframa terms, nicotine ecommerce rules, website policy, legal agreement"
  structuredData={{
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Terms and Conditions",
    description:
      "Full usage policy and terms of service for visitors and customers of Pufframa.com, a nicotine product platform. Includes liability, conduct, and legal details.",
    url: "https://pufframa.com/terms-and-conditions"
  }}
/>

      <h1 className="text-3xl font-bold mb-8 text-center">Terms and Conditions</h1>

      <p className="mb-6 text-sm text-gray-600 italic">
        PLEASE READ THE FOLLOWING TERMS AND CONDITIONS OF USE CAREFULLY BEFORE USING THIS WEBSITE.
      </p>

      <section className="mb-8">
        <p>
          By accessing and using this site, you agree to be bound by the terms, conditions, and applicable laws detailed below.
          You must be at least <strong>21 years old</strong> (or the legal age in your state) to purchase products on this site.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">Copyright</h2>
        <p>
          All content on this website—including but not limited to text, graphics, logos, and code—is the property of{" "}
          <strong>Pufframa.com</strong> and is protected under U.S. and international copyright laws.
          You may print or download materials for non-commercial use or placing an order.
          Any other use is strictly prohibited without written permission.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">Limitation of Liability</h2>
        <p>
          Pufframa.com shall not be liable for any damages resulting from the use—or inability to use—any content or products from this site.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">Typographical Errors</h2>
        <p>
          In the event a product is mistakenly listed at an incorrect price, we reserve the right to cancel or refuse any order placed at that price,
          whether or not your order has been confirmed or payment processed. A full refund will be issued if your card was charged.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">Term & Termination</h2>
        <p>
          These terms apply upon your accessing the site and/or registering or purchasing. Pufframa.com may terminate these terms at any time.
          Sections like Copyrights, Limitations, and Legal Rights will survive termination.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">Notice</h2>
        <p>
          Pufframa.com may send notices to your email, post general announcements on the site, or use your registered contact details for communication.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">Governing Law</h2>
        <p>
          Your use of this site shall be governed by the laws of the State of Virginia, USA. Disputes must be resolved in Richmond, Virginia.
          Legal claims must be filed within 3 months of the issue arising.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">Use of Site</h2>
        <p>
          Users must not harass, impersonate, post obscene content, or break any laws while using the site.
          Commercial solicitation and uploading malicious content are prohibited.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">Participation Disclaimer</h2>
        <p>
          We are not responsible for user-generated content but reserve the right to remove material that violates policies or is deemed inappropriate.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">Indemnification</h2>
        <p>
          You agree to indemnify and hold harmless Pufframa.com and its team from any claims arising from your account use or violation of these terms.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">Third-Party Links</h2>
        <p>
          This site may contain links to third-party websites.Pufframa.com is not responsible for their content or privacy practices.
          Use them at your own discretion. Feedback on third-party links is welcome.
        </p>
      </section>
    </div>
  );
};

export default Terms;
